import LeftArrow from "Assets/Icons/LeftArrow";
import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import Typography from "Components/CommonComponents/Typography";
import { FormInput } from "Components/InputComponents/FormInput";
import { SelectHookForm } from "Components/InputComponents/SelectHookForm";
import { ToastContextDispatch } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import moment from "moment";
import { createRef, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Col, Row, Spinner } from "reactstrap";
import { FexRoles, Frequency } from "utilFunctions/Constants/Constants";
import {
  BASE_URL,
  CREATE_NOTIFICATION,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import {
  getOptionIndex,
  getOptionIndexMultiForBranch,
  returnMultipleValues,
} from "utilFunctions/helperFunctions/HelperFunction";
import {
  HeaderMainDiv,
  BodyMainDiv,
  FooterMainDiv,
} from "utilFunctions/shared/StyledComponent/StyledComponent";

interface NotificationsCreateAndUpdate {
  openFormHandler: any;
  selectedNotification: any;
  formLoading: boolean;
  region: any[];
  setSelectedNotification: any;
  getNotificationsHandler: any;
}
const styleCSS: any = {
  style: {
    flexDirection: "column",
  },
};
const NotificationsCreateAndUpdate = ({
  formLoading,
  selectedNotification,
  openFormHandler,
  region,
  setSelectedNotification,
  getNotificationsHandler,
}: NotificationsCreateAndUpdate) => {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<any>();
  const ref = createRef<HTMLInputElement>();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { screen }: any = useWindowSize();
  const { masters } = useMasterContext();
  const [branchOptions, setBranchOptions] = useState<any>(masters?.branches);
  const { makeRequest: createNotification } = usePutPostAPI(
    (data: any) => {
      setSelectedNotification(data);
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data?.message,
      });
      openFormHandler();
      getNotificationsHandler();
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error?.response?.data?.message || error?.message,
      });
    },
    "POST"
  );
  const { makeRequest: updateNotification } = usePutPostAPI(
    (data: any) => {
      setSelectedNotification(data);
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data?.message,
      });
      openFormHandler();
      getNotificationsHandler();
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error?.response?.data?.message || error?.message,
      });
    },
    "PUT"
  );
  const handleSelectedOptionFromSelect = (type: string, data: any) => {
    const selectedNotificationCopy = { ...selectedNotification };
    selectedNotificationCopy[type] = data;
    if (type == "regionId") {
      selectedNotificationCopy["branchId"] = null;
      setValue("branchId", null);
    }
    setSelectedNotification({ ...selectedNotificationCopy });
  };
  const handleOptionForBranches = (regionIds: any) => {
    const newRegionids =
      regionIds &&
      Array.isArray(regionIds) &&
      regionIds.map((item: any) => String(item));
    if (newRegionids && masters && Array.isArray(masters?.branches)) {
      const filteredbranches = masters?.branches.filter((item: any) =>
        newRegionids.includes(String(item.region))
      );
      setBranchOptions(filteredbranches);
    }
  };
  const onSubmit = handleSubmit((formValues: any) => {
    const newObj: any = {
      templateId: Number(formValues.templateId),
      frequency: formValues?.frequency?.value,
      regionId: formValues?.regionId?.map((ele: any) => ele.value),
      branchId: formValues?.branchId?.map((ele: any) => ele.id),
      role: formValues?.role?.map((ele: any) => ele.value),
      scheduleAt: formValues?.scheduleAt + ":00.000+05:30",
      urlLink: formValues?.urlLink,
    };
    if (selectedNotification.id) {
      newObj["id"] = selectedNotification.id;
      updateNotification(BASE_URL + CREATE_NOTIFICATION, newObj);
    } else {
      createNotification(BASE_URL + CREATE_NOTIFICATION, newObj);
    }
  });

  const returnRoles = (arr: any) => {
    return FexRoles?.filter((ele: any) => arr?.includes(ele.value));
  };
  const getCurrentDateTime = () => {
    return moment(new Date()).format("YYYY-MM-DDTHH:mm");
  };
  return (
    <form onSubmit={onSubmit} className="mx-auto">
      <HeaderMainDiv>
        <LeftArrow
          className={"cursorHoverCSS mr-1"}
          onClick={openFormHandler}
        />
        <Typography
          variant={["xs", "sm", "md"].includes(screen) ? "h6" : "h4"}
          color="black"
        >
          Notification
        </Typography>
      </HeaderMainDiv>
      <BodyMainDiv>
        {formLoading ? (
          <Spinner color="info"></Spinner>
        ) : (
          <div>
            <Row className="d-flex flex-row align-items-center mt-2 mb-3 gap-4">
              <Col xs="4" sm="4">
                <label className="pt-2">Template ID</label>
              </Col>
              <Col xs="7" sm="7">
                <FormInput<LoginFormFields>
                  ref={ref}
                  id="templateId"
                  type="number"
                  name="templateId"
                  defaultValue={selectedNotification?.templateId}
                  placeholder="Enter templateId "
                  required={true}
                  className="d-flex mw-100 flex-column"
                  register={register}
                  rules={{
                    required: "You must enter templateId.",
                  }}
                  errors={errors}
                  {...styleCSS}
                />
              </Col>

              <Col xs="4" sm="4">
                <label className="pt-2">Date Time</label>
              </Col>
              <Col xs="7" sm="7">
                <input
                  type="datetime-local"
                  min={getCurrentDateTime()}
                  defaultValue={
                    selectedNotification?.scheduleAt
                      ? moment(selectedNotification?.scheduleAt).format(
                          "YYYY-MM-DDTHH:mm"
                        )
                      : undefined
                  }
                  required={true}
                  className="datePicker"
                  {...register("scheduleAt", {
                    required: "You must enter scheduleAt.",
                  })}
                />
                {errors.scheduleAt && (
                  <p className="error-message">{"You must enter scheduleAt"}</p>
                )}
              </Col>
              <Col xs="4" sm="4">
                <label className="pt-1">Frequency</label>
              </Col>
              <Col xs="7" sm="7">
                <SingleSelectHookForm
                  error={errors}
                  controlName={control}
                  placeholder="Select frequency"
                  width="100%"
                  isInPerformance={false}
                  options={Frequency}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name={"frequency"}
                  register={register}
                  rules={{
                    required: "You must select frequency.",
                  }}
                  onChange={(e: any) => {
                    console.log(e);
                  }}
                  defaultValue={getOptionIndex(
                    selectedNotification?.frequency,
                    Frequency
                  )}
                />
              </Col>
              <Col xs="4" sm="4">
                <label>Region</label>
              </Col>
              <Col xs="7" sm="7">
                <SelectHookForm
                  error={errors}
                  required={true}
                  controlName={control}
                  placeholderLabel="Select region"
                  width="100%"
                  isInPerformance={true}
                  options={region}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  name={"regionId"}
                  register={register}
                  rules={{
                    required: "You must select region.",
                  }}
                  onChange={(selected: any) => {
                    const regionIds = selected.map((item: any) => item.value);
                    console.log(regionIds, "regionIdsregionIds");
                    handleSelectedOptionFromSelect("regionId", regionIds);
                    setBranchOptions([]);
                    handleOptionForBranches(regionIds);
                  }}
                  defaultValue={returnMultipleValues(
                    selectedNotification?.regionId,
                    region
                  )}
                />
              </Col>
              <Col xs="4" sm="4">
                <label>Branch</label>
              </Col>
              <Col xs="7" sm="7">
                <SelectHookForm
                  error={errors}
                  required={true}
                  controlName={control}
                  placeholderLabel="Select branch"
                  width="100%"
                  isInPerformance={true}
                  options={branchOptions}
                  menuPlacement="auto"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  name={"branchId"}
                  register={register}
                  rules={{
                    required: "You must select branch.",
                  }}
                  onChange={(selected: any) => {
                    const branchids = selected.map((item: any) => item.id);
                    handleSelectedOptionFromSelect("branchId", branchids);
                  }}
                  defaultValue={getOptionIndexMultiForBranch(
                    selectedNotification?.branchId,
                    branchOptions
                  )}
                />
              </Col>
              <Col xs="4" sm="4">
                <label className="pt-1">Role</label>
              </Col>
              <Col xs="7" sm="7">
                <SelectHookForm
                  error={errors}
                  required={true}
                  controlName={control}
                  placeholderLabel="Select role"
                  width="100%"
                  isInPerformance={true}
                  options={FexRoles}
                  menuPlacement="top"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  name={"role"}
                  register={register}
                  rules={{
                    required: "You must select branch.",
                  }}
                  onChange={(selected: any) => {
                    const role = selected.map((item: any) => item.value);
                    handleSelectedOptionFromSelect("role", role);
                  }}
                  defaultValue={returnRoles(selectedNotification?.role)}
                />
              </Col>
              <Col xs="4" sm="4">
                <label className="pt-2">Attachment Url</label>
              </Col>
              <Col xs="7" sm="7">
                <FormInput<LoginFormFields>
                  ref={ref}
                  id="urlLink"
                  type="text"
                  name="urlLink"
                  defaultValue={selectedNotification?.urlLink}
                  placeholder="Enter attachment url "
                  required={false}
                  className="d-flex mw-100 flex-column"
                  register={register}
                  errors={errors}
                  {...styleCSS}
                />
              </Col>
            </Row>
          </div>
        )}
      </BodyMainDiv>
      <FooterMainDiv screen={screen}>
        {["xs", "sm", "md"].includes(screen) ? null : (
          <Button
            outline
            type="reset"
            color="aeslPrimary"
            className="mt-3 w-20"
            onClick={() => {
              openFormHandler();
            }}
          >
            Cancel
          </Button>
        )}
        <Button
          type="submit"
          color="aeslPrimary"
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "mt-3 text-white w-100"
              : "mt-3 text-white w-20"
          }
        >
          Save
        </Button>
      </FooterMainDiv>
    </form>
  );
};
export default NotificationsCreateAndUpdate;
